import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_defaultDispatcher() {
  return Dispatchers_getInstance().i13_1;
}
//region block: exports
export {
  get_defaultDispatcher as get_defaultDispatcher3rblue9uzsji2,
};
//endregion

//# sourceMappingURL=dispatchers.js.mjs.map
